import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoConcorso = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 30,
	viewBox: "0 0 24 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "Marker Box",
		filter: "url(#filter0_d_2466_14996)",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Monumenti",
			children: /* @__PURE__ */ _jsx("path", {
				id: "shape",
				d: "M12.0727 10.7932L11.9996 10.8663L11.9265 10.7932L11.4406 10.3073C11.6207 10.3463 11.8078 10.3668 11.9996 10.3668C12.1914 10.3668 12.3785 10.3463 12.5586 10.3073L12.0727 10.7932ZM9.42569 8.29238L9.2385 8.10519L8.04382 6.91056L7.70225 6.569L7.34912 6.89858C5.97629 8.17986 5.09961 9.97299 5.09961 12.0001C5.09961 15.8175 8.18213 18.9001 11.9996 18.9001C15.8171 18.9001 18.8996 15.8175 18.8996 12.0001C18.8996 9.97299 18.023 8.17987 16.6501 6.89858L16.297 6.569L15.9554 6.91056L14.7607 8.10519L14.5735 8.29243C14.6124 8.11227 14.6329 7.92525 14.6329 7.73343C14.6329 6.27909 13.4539 5.1001 11.9996 5.1001C10.5452 5.1001 9.36625 6.27909 9.36625 7.73343C9.36625 7.92523 9.38675 8.11223 9.42569 8.29238Z",
				fill: "#4A4A4A",
				stroke: "white"
			})
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_2466_14996",
		x: -2,
		y: -2,
		width: 30,
		height: 36,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 1,
				dy: 1
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0.46 0 0 0 0 1 0 0 0 0.41 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_2466_14996"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_2466_14996",
				result: "shape"
			})
		]
	}) })]
});
export default SvgNoConcorso;
